(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7385],{

/***/ 98913:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(22545),
    castFunction = __webpack_require__(54290),
    toInteger = __webpack_require__(40554);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = toInteger(n);
  if (n < 1 || n > MAX_SAFE_INTEGER) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH,
      length = nativeMin(n, MAX_ARRAY_LENGTH);

  iteratee = castFunction(iteratee);
  n -= MAX_ARRAY_LENGTH;

  var result = baseTimes(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

module.exports = times;


/***/ }),

/***/ 42886:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/liquidity",
      function () {
        return __webpack_require__(18070);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 18070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ liquidity; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 21 modules
var src = __webpack_require__(1505);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(74566);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(29439);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(45388);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var wagmi_src = __webpack_require__(29315);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 1 modules
var localization_src = __webpack_require__(68486);
// EXTERNAL MODULE: ./src/views/Swap/StableSwap/hooks/useStableConfig.ts + 3 modules
var useStableConfig = __webpack_require__(12353);
// EXTERNAL MODULE: ./src/components/Layout/PageFullWidth.tsx
var PageFullWidth = __webpack_require__(38047);
// EXTERNAL MODULE: ./src/components/Menu/SubNav.tsx
var SubNav = __webpack_require__(21281);
// EXTERNAL MODULE: ./src/components/PositionCard/index.tsx
var PositionCard = __webpack_require__(26688);
// EXTERNAL MODULE: ./src/state/wallet/hooks.ts
var hooks = __webpack_require__(5460);
// EXTERNAL MODULE: ./src/hooks/usePairs.ts
var usePairs = __webpack_require__(71633);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var user_hooks = __webpack_require__(921);
// EXTERNAL MODULE: ./src/components/Loader/Dots.tsx
var Dots = __webpack_require__(32519);
// EXTERNAL MODULE: ./src/views/Swap/components/AppHeader.tsx
var AppHeader = __webpack_require__(40588);
;// CONCATENATED MODULE: ./src/views/Pool/index.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\nposition: relative;\npadding: 2rem;\nborder-radius: 20px;\nbox-shadow: 0px 10px 14px -48px rgb(31 47 70 / 12%);\nbackground: #FCFCFD;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: -18px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 20px 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 5px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: space-around;\n  padding-left: 20px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  max-width: 450px;\n  width: 100%;\n  z-index: 5;\n  background: ",
        ";\n  backdrop-filter: blur(20px);\n  border-radius: 20px;\n  margin-bottom: 30px;\n  box-shadow: 0px 54px 54px -48px rgba(31, 47, 70, 0.12);\n  @media only screen and (max-width: 600px) {\n    margin-left: 16px;\n    margin-right: 16px;\n    width: 98%;\n    padding: 0px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
















var Body = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba9d6202-0"
})(_templateObject());
function Pool() {
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    // fetch the user's balances of all tracked V2 LP tokens
    var trackedTokenPairs = (0,user_hooks/* useTrackedTokenPairs */.B3)();
    var tokenPairsWithLiquidityTokens = (0,react.useMemo)(function() {
        return trackedTokenPairs.map(function(tokens) {
            return {
                liquidityToken: (0,user_hooks/* toV2LiquidityToken */.Ce)(tokens),
                tokens: tokens
            };
        });
    }, [
        trackedTokenPairs
    ]);
    var liquidityTokens = (0,react.useMemo)(function() {
        return tokenPairsWithLiquidityTokens.map(function(tpwlt) {
            return tpwlt.liquidityToken;
        });
    }, [
        tokenPairsWithLiquidityTokens
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useTokenBalancesWithLoadingIndicator */.v2)(account !== null && account !== void 0 ? account : undefined, liquidityTokens), 2), v2PairsBalances = ref[0], fetchingV2PairBalances = ref[1];
    var stablePairs = (0,useStableConfig/* useLPTokensWithBalanceByAccount */.f8)(account);
    // fetch the reserves for all V2 pools in which the user has a balance
    var liquidityTokensWithBalances = (0,react.useMemo)(function() {
        return tokenPairsWithLiquidityTokens.filter(function(param) {
            var liquidityToken = param.liquidityToken;
            var ref;
            return (ref = v2PairsBalances[liquidityToken.address]) === null || ref === void 0 ? void 0 : ref.greaterThan("0");
        });
    }, [
        tokenPairsWithLiquidityTokens,
        v2PairsBalances
    ]);
    var v2Pairs = (0,usePairs/* usePairs */.z$)(liquidityTokensWithBalances.map(function(param) {
        var tokens = param.tokens;
        return tokens;
    }));
    var v2IsLoading = fetchingV2PairBalances || (v2Pairs === null || v2Pairs === void 0 ? void 0 : v2Pairs.length) < liquidityTokensWithBalances.length || (v2Pairs === null || v2Pairs === void 0 ? void 0 : v2Pairs.length) && v2Pairs.every(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 1), pairState = _param[0];
        return pairState === usePairs/* PairState.LOADING */._G.LOADING;
    });
    var allV2PairsWithLiquidity = v2Pairs === null || v2Pairs === void 0 ? void 0 : v2Pairs.filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), pairState = _param[0], pair = _param[1];
        return pairState === usePairs/* PairState.EXISTS */._G.EXISTS && Boolean(pair);
    }).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), pair = _param[1];
        return pair;
    });
    var renderBody = function() {
        if (!account) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "#000",
                textAlign: "center",
                children: t("Connect to a wallet to view your liquidity.")
            });
        }
        if (v2IsLoading) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "textSubtle",
                textAlign: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dots/* default */.Z, {
                    children: t("Loading")
                })
            });
        }
        var positionCards = [];
        if ((allV2PairsWithLiquidity === null || allV2PairsWithLiquidity === void 0 ? void 0 : allV2PairsWithLiquidity.length) > 0) {
            positionCards = allV2PairsWithLiquidity.map(function(v2Pair, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(PositionCard/* default */.ZP, {
                    pair: v2Pair,
                    mb: Boolean(stablePairs === null || stablePairs === void 0 ? void 0 : stablePairs.length) || index < allV2PairsWithLiquidity.length - 1 ? "16px" : 0
                }, v2Pair.liquidityToken.address);
            });
        }
        if ((stablePairs === null || stablePairs === void 0 ? void 0 : stablePairs.length) > 0) {
            positionCards = (0,_to_consumable_array/* default */.Z)(positionCards).concat((0,_to_consumable_array/* default */.Z)(stablePairs === null || stablePairs === void 0 ? void 0 : stablePairs.map(function(stablePair, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PositionCard/* StableFullPositionCard */.uK, {
                    pair: stablePair,
                    mb: index < stablePairs.length - 1 ? "16px" : 0
                }, "stable-".concat(stablePair.liquidityToken.address));
            })));
        }
        if ((positionCards === null || positionCards === void 0 ? void 0 : positionCards.length) > 0) {
            return positionCards;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            color: "#000",
            textAlign: "center",
            children: t("No liquidity found.")
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageFullWidth/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubNav/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapAppBody, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                        id: "liquidity-page",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppHeader/* default */.Z, {
                                title: t("Your Liquidity"),
                                subtitle: t("Remove liquidity to receive tokens back")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/add",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        style: {
                                            width: "100%",
                                            borderRadius: "12px"
                                        },
                                        id: "join-pool-button",
                                        as: "a",
                                        children: t("Add Liquidity")
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    marginTop: "1rem"
                                },
                                children: [
                                    renderBody(),
                                    account && !v2IsLoading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        flexDirection: "column",
                                        alignItems: "center",
                                        mt: "24px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                color: "#000",
                                                mb: "8px",
                                                children: t("Don't see a pool you joined?")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/find",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    style: {
                                                        width: "100%",
                                                        borderRadius: "12px"
                                                    },
                                                    id: "import-pool-link",
                                                    as: "a",
                                                    children: t("Find other LP tokens")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba9d6202-1"
})(_templateObject1());
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba9d6202-2"
})(_templateObject2());
var CustomToken = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ba9d6202-3"
})(_templateObject3());
var WrapIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba9d6202-4"
})(_templateObject4());
var CustomFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ba9d6202-5"
})(_templateObject5());
var WrapAppBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba9d6202-6"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
});

;// CONCATENATED MODULE: ./src/pages/liquidity.tsx



var LiquidityPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Pool, {});
};
LiquidityPage.chains = [
    src/* ChainId */.a_ === null || src/* ChainId */.a_ === void 0 ? void 0 : src/* ChainId.BASE_GOERLI */.a_.BASE_GOERLI,
    src/* ChainId.BASE_MAINNET */.a_.BASE_MAINNET
];
/* harmony default export */ var liquidity = (LiquidityPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5932,724,1372,921,6556,2309,140,6688,9774,2888,179], function() { return __webpack_exec__(42886); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);